import { ExamId, Field, Transition, Workflow } from '@parsys/frontend_library';

import { getExam } from './getExam';

type GetChoiceLabelFromFieldValueArgs = {
  workflow: Workflow,
  transitionId: Transition['id'],
  formId: ExamId,
  sectionId: Field['id'],
  fieldId: Field['id'],
  fieldValue: unknown
}

// Default to 'create' transition as it's the one where most of the form values are stored but this can be easily overridden if needed.
export const getChoiceLabelFromFieldValue = ({ workflow, transitionId = 'create', formId, sectionId, fieldId, fieldValue }: GetChoiceLabelFromFieldValueArgs) => {
  if (!fieldValue) {
    return '';
  }
  const targetedExamForm = getExam({
    workflow,
    transitionId,
    examId: formId,
  });

  if (!targetedExamForm) {
    console.error('workflow incompatible with intervention feature');
    return '';
  }
  const formList = targetedExamForm.pages[0].fields;
  let field = null;
  if (sectionId) {
    field = formList.find(item => item.id === sectionId)?.fields
      ?.find(field => field.id === fieldId) ?? null;
  } else {
    // If no sectionId is provided, we look for the field in the whole form.
    // We first look for the field at the top level of the form, then we look for it in each section of the form.
    for (const item of formList) {
      if (item.id === fieldId) {
        field = item; break;
      }
      const nested = item.fields?.find(field => field.id === fieldId);
      if (nested) {
        field = nested; break;
      }
    }
  }
  const isChoicesList = field?.choices;
  const optionList = isChoicesList ? field.choices : field.groupChoices;
  if (!optionList) {
    return null;
  }
  let labelList;
  if (isChoicesList) {
    if (Array.isArray(fieldValue)) {
      labelList = fieldValue.map((value) => {
        return optionList.find((option) => option.value === value)?.label;
      }).join(', ');
    } else {
      labelList = optionList.find((option) => option.value === fieldValue)?.label;
    }
  } else {
    // Find label in groupChoices list.
    const allOptions = optionList.reduce((acc, { options }) => {
      acc.push(...options);
      return acc;
    }, []);

    if (Array.isArray(fieldValue)) {
      labelList = fieldValue.map(value => {
        return allOptions.find((option) => option.value === value)?.label;
      }).join(', ');
    } else {
      labelList = allOptions.find(({ value }) => value === fieldValue)?.label;
    }
  }

  return labelList;
};
